"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fileMimeTypes = _interopRequireDefault(require("./fileMimeTypes"));

var _formats = _interopRequireDefault(require("./formats"));

var _genders = _interopRequireDefault(require("./genders"));

var _notificationTypes = _interopRequireDefault(require("./notificationTypes"));

var _regex = _interopRequireDefault(require("./regex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  FILE_MIME_TYPES: _fileMimeTypes.default,
  FORMATS: _formats.default,
  NOTIFICATION_TYPES: _notificationTypes.default,
  REGEX: _regex.default,
  GENDERS: _genders.default
};
exports.default = _default;